import { timeStampEpochRequired, labeled, stringRequired } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    name: stringRequired(Joi, 1, 64).label(labeled(label, 'Name')),
    dateOfBirth: timeStampEpochRequired(Joi).label(labeled(label, 'Date of birth'))
  });

export default {
  schema
};
